import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { LOAN_DELETE_LOAN_SECURITY_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class DeleteLoanLoanSecurity extends BaseApiRequest {
  method = METHOD.HTTP.DELETE;

  body = {};

  url = LOAN_DELETE_LOAN_SECURITY_URL;

  constructor(applicationId, securityId) {
    super();
    const paramList = [applicationId, securityId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
